// Port of api/fuel/app/classes/insights/size/turnover.php

import Segment from 'offline/insights/segment'
import Constants from 'offline/constants'
import Util from 'offline/util'
import Config from 'offline/model/config'
import Play from 'offline/model/play'

function excludeExpansions(ownerId) {
	var config = Config.user(ownerId)
	return !!(((config || {}).insights || {}).size || {}).expansions
}

export default Segment.extend({
	name: 'turnover',
	types: [Constants.TYPE_USER],
	insight: false,
	detail: ['turnover'],
	run: function(type, owner, userIndex, detail, filter, vars) {
		if (!owner.get_count_collection()) return {}

		var exclude = excludeExpansions(vars && vars.sessionUserId)
		var x = vars.x !== undefined ? parseInt(vars.x, 10) : 0
		var y = vars.y !== undefined ? parseInt(vars.y, 10) : 0
		if (isNaN(x)) x = 0
		if (isNaN(y)) y = 0
		var turnover = []

		var trackedRows = Util.queryFast(
			'SELECT g.game_id AS g, l.log_date AS d, l.log_context AS c' +
			' FROM log_user_collection l, game g' +
			' WHERE l.log_context IN(' + Util.in([Constants.LOG_CONTEXT_ADDED, Constants.LOG_CONTEXT_REMOVED]) + ')' +
			(exclude ? ' AND g.game_type = 1' : '') +
			' AND l.game_id = g.game_id AND l.user_id = ' + owner.get_id() +
			' ORDER BY l.log_date ASC, l.log_id ASC'
		)
		var tracked = {}
		// Insertion order matters — PHP's assoc-array-by-game_id preserves
		// query-encounter order. JS's `Object.keys` with integer-like keys
		// returns them in ascending numeric order instead, so the turnover
		// emission order diverges. Track first-seen order explicitly.
		var trackedOrder = []

		for (var i = 0; i < trackedRows.length; i++) {
			var row = trackedRows[i]
			var gameId = parseInt(row.g, 10)
			if (!tracked[gameId]) {
				tracked[gameId] = []
				trackedOrder.push(gameId)
			}
			tracked[gameId].push({
				g: gameId,
				d: parseInt(row.d, 10) || 0,
				c: parseInt(row.c, 10) || 0
			})
		}

		if (process.env.DEBUG_TURNOVER) console.error('[DEBUG TURNOVER] trackedRows=' + trackedRows.length + ' trackedGames=' + trackedOrder.length)
		for (var j = 0; j < trackedOrder.length; j++) {
			var group = tracked[trackedOrder[j]]
			var addedDate = false
			var addedCount = 0

			for (var k = 0; k < group.length; k++) {
				var item = group[k]
				if (item.c === Constants.LOG_CONTEXT_ADDED) {
					addedCount++
					if (!addedDate) addedDate = item.d
				} else if (item.c === Constants.LOG_CONTEXT_REMOVED) {
						if (addedCount) {
							addedCount--
							if (!addedCount) {
								turnover.push({
									g: item.g,
									d: (Util.date_start(item.d) - Util.date_start(addedDate)) / Constants.TIME_DAY,
									p: Play.total({
										where: [
											['user_id', '=', owner.get_id()],
											['game_id', '=', item.g],
											['play_date', '<=', Util.date_end(item.d)],
											['play_date', '>=', Util.date_start(addedDate)]
										]
									})
								})
								addedDate = false
							}
					}
				}
			}
		}

		if (detail) {
			var thresholds = {
				x: {
					0: [0, 10],
					1: [11, 100],
					2: [101, 500],
					3: [501, 1000],
					4: [1001, 1000000]
				},
				y: {
					0: [0, 0],
					1: [1, 1],
					2: [2, 5],
					3: [6, 10],
					4: [11, 1000000]
				}
			}
			var games = []

			for (var t = 0; t < turnover.length; t++) {
				var current = turnover[t]
				if (
					current.p >= thresholds.y[y][0] && current.p <= thresholds.y[y][1] &&
					current.d >= thresholds.x[x][0] && current.d <= thresholds.x[x][1]
				) {
					this._references.games.push(current.g)
					games.push({
						id: current.g,
						days: current.d,
						plays: current.p
					})
				}
			}

			games = Util.sort_by_field(games, 'plays', 'desc')
			return { games: games }
		}

		return {
			turnover: turnover
		}
	}
})
